import FieldItem from './FieldItem';

FieldItem.install = function(Vue) {
    Vue.component(FieldItem.name, FieldItem);
};

export default FieldItem;